<template>
  <div>
    <b-modal id="modal-input" size="lg" centered :title="$store.state.modal.tambahLoker" header-bg-variant="primary" header-text-variant="light">
      <!-- Stepper -->
      <div class="d-flex justify-content-center mb-4">
        <ul class="stepper list-unstyled d-flex">
          <li :class="['step', currentStep === 1 ? 'active' : '', currentStep > 1 ? 'completed' : '']">
            <span>1</span>
            <p class="mb-0">Job Vacancy Data</p>
          </li>
          <li :class="['step', currentStep === 2 ? 'active' : '', currentStep > 2 ? 'completed' : '']">
            <span>2</span>
            <p class="mb-0">Job Vacancy Admin Document Requirements</p>
          </li>
        </ul>
      </div>

      <!-- Step 1 -->
      <div v-if="currentStep === 1">
        <input-tab-loker @dataFromChild="fromData($event)" :divisi="divisi" :default-data="dataLoker" />
      </div>

      <!-- Step 2 -->
      <div v-if="currentStep === 2">
        <input-tab-dok-loker @dokumenFromChild="fromDokumen($event)" :dokumen="dokumen" :default-dokumen="dataDokumen" />
      </div>

      <template #modal-footer>
        <b-button v-if="currentStep > 1" variant="secondary" class="rounded-pill px-4" @click="prevStep">
          {{ $store.state.form.sebelumnya }}
        </b-button>

        <b-button v-if="currentStep < 2" variant="primary" class="rounded-pill px-4" @click="nextStep" :disabled="!canProceed">
          {{ $store.state.form.selanjutnya }}
        </b-button>

        <b-button v-if="currentStep === 2" :disabled="busy || !dataLoker || !dataDokumen.length" variant="primary" class="rounded-pill px-4" v-b-modal.modal-konfirmasi-input>
          {{ button }}
        </b-button>
      </template>
    </b-modal>

    <!-- Confirmation Modal -->
    <b-modal id="modal-konfirmasi-input" size="md" centered :title="$store.state.modal.konfirmasiInputLoker" header-bg-variant="info" header-text-variant="light">
      <p>{{ $store.state.text.konfirmasiDataLoker }}</p>

      <template #modal-footer>
        <b-button variant="secondary" class="rounded-pill px-4" @click="batal">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" class="rounded-pill px-4" :disabled="busy" @click="create">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import inputTabLoker from "./inputTabLoker.vue";
import inputTabDokLoker from "./inputTabDokLoker.vue";

export default {
  components: {
    inputTabLoker,
    inputTabDokLoker,
  },
  name: "modalInput",
  props: ["divisi", "dokumen"],
  data() {
    return {
      button: "Simpan",
      busy: false,
      currentStep: 1,
      dataLoker: {
        namaLoker: "",
        keteranganLoker: "",
        tanggalAkhirLoker: "",
        umurMinimal: "",
        umurMaksimal: "",
        masterPosisiId: "",
        file1: null,
      },
      dataDokumen: [],
    };
  },
  computed: {
    canProceed() {
      if (this.currentStep === 1) {
        return this.dataLoker && this.dataLoker.namaLoker !== "" && this.dataLoker.masterPosisiId;
      }
      return true;
    },
  },
  methods: {
    nextStep() {
      if (this.currentStep < 2) this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },
    fromData(data) {
      this.dataLoker = data;
    },
    fromDokumen(data) {
      this.dataDokumen = data.data;
    },
    create() {
      let vm = this;
      let tglAkhir = vm.$moment(vm.dataLoker.tanggalAkhirLoker);
      let bulkKebutuhan = vm.dataDokumen.map((el) => ({
        masterKebutuhanId: el.masterKebutuhanId,
      }));

      vm.busy = true;
      vm.button = "Mohon Tunggu";

      let formData = new FormData();
      if (vm.$store.state.mitra_aktif) formData.append("mitraId", vm.$store.state.mitra_aktif.id);
      formData.append("namaLoker", vm.dataLoker.namaLoker);
      formData.append("keteranganLoker", vm.dataLoker.keteranganLoker);
      formData.append("tanggalAkhirLoker", tglAkhir);
      formData.append("umurMinimal", vm.dataLoker.umurMinimal);
      formData.append("umurMaksimal", vm.dataLoker.umurMaksimal);
      formData.append("masterPosisiId", vm.dataLoker.masterPosisiId);
      formData.append("bulkKebutuhan", JSON.stringify(bulkKebutuhan));
      if (vm.dataLoker.file1) {
        formData.append("file1", vm.dataLoker.file1);
      }

      vm.$axios
        .post("loker/register", formData)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN MASTER LOWONGAN KERJA",
              showing: true,
            });
            vm.resetForm();
            vm.$bvModal.hide("modal-input");
            vm.$bvModal.hide("modal-konfirmasi-input");
          } else {
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            vm.busy = false;
            this.button = "Simpan";
          }
        })
        .catch(() => {
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          vm.busy = false;
          this.button = "Simpan";
        });
    },
    batal() {
      this.$bvModal.hide("modal-konfirmasi-input");
    },
    resetForm() {
      this.dataLoker = {
        namaLoker: "",
        keteranganLoker: "",
        tanggalAkhirLoker: "",
        umurMinimal: "",
        umurMaksimal: "",
        masterPosisiId: "",
        file1: null,
      };
      this.dataDokumen = [];
      this.currentStep = 1;
      this.busy = false;
      this.button = "Simpan";
    },
  },
};
</script>

<style scoped>
.stepper {
  gap: 40px;
}
.step {
  text-align: center;
  position: relative;
}
.step span {
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  line-height: 32px;
  background: #ccc;
  color: #fff;
}
.step.active span {
  background: #007bff;
}
.step.completed span {
  background: #28a745;
}
.step::after {
  content: "";
  position: absolute;
  top: 16px;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #ccc;
  z-index: -1;
}
.step:last-child::after {
  display: none;
}
</style>
